(function () {

    if (!window.jQuery) {
        return;
    }

    var $ = window.jQuery;

    /**
     * Normalize text values for accessibility label composition.
     * @param {string} value - Raw text value.
     * @returns {string} Normalized value.
     */
    function normalizeText(value) {
        return String(value || '').replace(/\s+/g, ' ').trim();
    }

    /**
     * Build contextual accessible name for menu promo links.
     * @param {string} linkText - Visible link text.
     * @param {string} contextText - Nearby descriptive context.
     * @returns {string} Contextual label.
     */
    function buildContextualLabel(linkText, contextText) {
        var normalizedLinkText = normalizeText(linkText);
        var normalizedContextText = normalizeText(contextText);

        if (!normalizedLinkText) {
            return '';
        }

        if (!normalizedContextText) {
            return normalizedLinkText;
        }

        if (normalizedContextText.toLowerCase().indexOf(normalizedLinkText.toLowerCase()) !== -1) {
            return normalizedContextText;
        }

        return normalizedLinkText + ' - ' + normalizedContextText;
    }

    /**
     * Apply contextual aria-label values to floating menu links.
     * @param {HTMLElement|Document} rootElement - Scope root.
     */
    function enhanceFloatingLinks(rootElement) {
        var $root = rootElement ? $(rootElement) : $(document);

        $root.find('.floating-link a').each(function () {
            var $link = $(this);

            if ($link.attr('aria-label')) {
                return;
            }

            var linkText = normalizeText($link.text());
            if (!linkText) {
                return;
            }

            var $promoImage = $link.closest('.promotional-image');
            var imageAlt = normalizeText($promoImage.find('img[alt]').first().attr('alt'));
            var imageTitle = normalizeText($promoImage.find('img[title]').first().attr('title'));
            var headingText = normalizeText($promoImage.find('h1, h2, h3, h4, h5, h6').first().text());
            var contextText = imageAlt || imageTitle || headingText;

            var contextualLabel = buildContextualLabel(linkText, contextText);
            if (contextualLabel) {
                $link.attr('aria-label', contextualLabel);
            }
        });
    }

    /**
     * Observe menu content injection and enhance newly added links.
     */
    function observeMenuContent() {
        if (!window.MutationObserver) {
            return;
        }

        var menuRoot = document.querySelector('.menu-group') || document.body;
        if (!menuRoot) {
            return;
        }

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (!mutation.addedNodes || !mutation.addedNodes.length) {
                    return;
                }

                Array.prototype.forEach.call(mutation.addedNodes, function (node) {
                    if (!node || node.nodeType !== 1) {
                        return;
                    }

                    if (node.matches('.floating-link, .promotional-images-outer, .submenu-container.right-content')
                        || node.querySelector('.floating-link a')) {
                        enhanceFloatingLinks(node);
                    }
                });
            });
        });

        observer.observe(menuRoot, {
            childList: true,
            subtree: true
        });
    }

    $(function () {
        enhanceFloatingLinks(document);
        observeMenuContent();
    });
})();
